/* FLAIRE SIGNUP — Gold Foil scratch card. Markup + styles: snippets/flaire-signup.liquid.
   Flow: scratch → prize → email → mobile (required) → code the customer copies.
   Contacts go to the Make relay, which upserts them into Omnisend. */
(function () {
  'use strict';
  var C = window.FLAIRE_SIGNUP;
  var ov = document.getElementById('fsg');
  if (!C || !ov || window.__fsgInit) return;
  window.__fsgInit = true;

  /* ---------- config ---------- */
  var MOBILE = window.matchMedia('(max-width: 749px)').matches;
  var DELAY_MS = MOBILE ? 8000 : 12000;   // time on page before auto-open
  var SCROLL_PCT = MOBILE ? 0.35 : 0.5;    // or scroll depth, whichever first
  var SNOOZE_DAYS = 7;                     // after a close, don't auto-open again for this long
  var REVEAL_AT = 0.4;                     // share of foil scratched before it gives way

  var params = new URLSearchParams(location.search);
  var TEST = params.get('fsg') === 'test';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- memory (all wrapped: private mode / blocked storage must never break the page) ---------- */
  function get(k) { try { return localStorage.getItem('fsg_' + k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem('fsg_' + k, v); } catch (e) {} }
  function sget(k) { try { return sessionStorage.getItem('fsg_' + k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem('fsg_' + k, v); } catch (e) {} }

  // People arriving from an Omnisend email are already on the list.
  if (params.get('omnisendContactID') || /omnisend/i.test(params.get('utm_source') || '')) set('done', '1');
  if (!TEST && get('done')) return;

  function track(name, data) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, data || {}); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }

  var $ = function (s, r) { return (r || ov).querySelector(s); };
  var steps = { scratch: $('[data-fsg-step="scratch"]'), email: $('[data-fsg-step="email"]'), sms: $('[data-fsg-step="sms"]'), done: $('[data-fsg-step="done"]') };
  var revealed = !!get('revealed');
  var isOpen = false, lastFocus = null, scratchReady = false;

  function show(step) {
    Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== step; });
    if (step === 'email') setTimeout(function () { var e = $('#fsg-email'); if (e) e.focus(); }, 60);
    if (step === 'sms') setTimeout(function () { var e = $('#fsg-phone'); if (e) e.focus(); }, 60);
  }

  /* ---------- open / close ---------- */
  function otherModalOpen() {
    return !!document.querySelector('cart-drawer.active, .drawer.active, details[open] > .menu-drawer, .upcart-drawer--open, #UpcartPopup[aria-hidden="false"]');
  }

  function open(source) {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    ov.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { ov.classList.add('is-in'); });
    if (get('claimed')) show('done');
    else if (get('email')) show('sms');
    else if (revealed) show('email');
    else { show('scratch'); initScratch(); }
    track('fsg_open', { source: source });
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    ov.classList.remove('is-in');
    document.documentElement.style.overflow = '';
    setTimeout(function () { ov.hidden = true; }, reduceMotion ? 0 : 350);
    if (get('claimed')) set('done', '1');
    else { set('snooze', String(Date.now())); track('fsg_close'); }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  ov.addEventListener('click', function (e) {
    if (e.target === ov || e.target.closest('[data-fsg-close]')) close();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });

  /* ---------- the scratch card ---------- */
  var cv = $('[data-fsg-canvas]'), fx = $('[data-fsg-fx]'), claimBtn = $('[data-fsg-claim]'), altBtn = $('[data-fsg-reveal]');

  function paintFoil(x, w, h) {
    var g = x.createLinearGradient(0, 0, w, h);
    g.addColorStop(0, '#8a6d38'); g.addColorStop(0.28, '#f1dca3'); g.addColorStop(0.52, '#b8904c');
    g.addColorStop(0.78, '#f4e2b0'); g.addColorStop(1, '#8a6d38');
    x.fillStyle = g; x.fillRect(0, 0, w, h);
    for (var i = 0; i < 1100; i++) {
      x.fillStyle = 'rgba(255,255,255,' + (Math.random() * 0.09) + ')';
      x.fillRect(Math.random() * w, Math.random() * h, 1.3, 1.3);
    }
    x.strokeStyle = 'rgba(90,64,20,.35)'; x.lineWidth = 1;
    x.strokeRect(10.5, 10.5, w - 21, h - 21);
    x.fillStyle = 'rgba(70,48,12,.62)';
    x.font = '600 15px Jost, sans-serif'; x.textAlign = 'center'; x.textBaseline = 'middle';
    x.fillText('S C R A T C H   H E R E', w / 2, h / 2);
    x.font = '500 20px "Cormorant Garamond", Georgia, serif';
    x.fillText('✦', w / 2, h / 2 - 28);
    x.fillText('✦', w / 2, h / 2 + 28);
  }

  function burst() {
    if (reduceMotion || !fx) return;
    var r = fx.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
    fx.width = r.width * dpr; fx.height = r.height * dpr;
    var x = fx.getContext('2d'); x.scale(dpr, dpr);
    var ps = [];
    for (var i = 0; i < 46; i++) {
      var a = Math.random() * Math.PI * 2, s = 2 + Math.random() * 4.5;
      ps.push({ x: r.width / 2, y: r.height / 2, vx: Math.cos(a) * s, vy: Math.sin(a) * s - 1.5, r: 1 + Math.random() * 2.4, life: 1 });
    }
    (function step() {
      x.clearRect(0, 0, r.width, r.height);
      var alive = false;
      ps.forEach(function (p) {
        if (p.life <= 0) return;
        alive = true;
        p.x += p.vx; p.y += p.vy; p.vy += 0.12; p.life -= 0.018;
        x.globalAlpha = Math.max(0, p.life);
        x.fillStyle = Math.random() > 0.5 ? '#E9D29B' : '#C8A76A';
        x.beginPath(); x.arc(p.x, p.y, p.r, 0, Math.PI * 2); x.fill();
      });
      if (alive) requestAnimationFrame(step); else x.clearRect(0, 0, r.width, r.height);
    })();
  }

  function onRevealed(how) {
    if (revealed && scratchReady === 'done') return;
    scratchReady = 'done';
    revealed = true; set('revealed', '1');
    cv.classList.add('is-done');
    altBtn.hidden = true;
    claimBtn.hidden = false;
    burst();
    try { if (navigator.vibrate) navigator.vibrate(18); } catch (e) {}
    track('fsg_reveal', { how: how });
    setTimeout(function () { claimBtn.focus(); }, 300);
  }

  function initScratch() {
    if (scratchReady) return;
    scratchReady = true;
    requestAnimationFrame(function () {
      var r = cv.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      cv.width = Math.round(r.width * dpr); cv.height = Math.round(r.height * dpr);
      var x = cv.getContext('2d'); x.scale(dpr, dpr);
      paintFoil(x, r.width, r.height);
      x.globalCompositeOperation = 'destination-out';
      var down = false, last = null, started = false, moves = 0;
      function pt(e) { var b = cv.getBoundingClientRect(); return { x: e.clientX - b.left, y: e.clientY - b.top }; }
      function draw(p) {
        x.strokeStyle = '#000'; // must be opaque: destination-out erases by stroke alpha
        x.lineWidth = Math.max(34, r.width / 9); x.lineCap = 'round'; x.lineJoin = 'round';
        x.beginPath(); x.moveTo((last || p).x, (last || p).y); x.lineTo(p.x + 0.1, p.y + 0.1); x.stroke();
        last = p;
      }
      function cleared() {
        var d = x.getImageData(0, 0, cv.width, cv.height).data, c = 0, n = 0;
        for (var i = 3; i < d.length; i += 64) { n++; if (d[i] === 0) c++; }
        return c / n;
      }
      cv.addEventListener('pointerdown', function (e) {
        if (scratchReady === 'done') return;
        down = true; last = null; cv.setPointerCapture(e.pointerId); draw(pt(e));
        if (!started) { started = true; track('fsg_scratch_start'); }
      });
      cv.addEventListener('pointermove', function (e) {
        if (!down || scratchReady === 'done') return;
        draw(pt(e));
        if (++moves % 12 === 0 && cleared() > REVEAL_AT) { down = false; onRevealed('scratch'); }
      });
      function up() { if (!down) return; down = false; last = null; if (cleared() > REVEAL_AT) onRevealed('scratch'); }
      cv.addEventListener('pointerup', up);
      cv.addEventListener('pointercancel', up);
    });
  }

  altBtn.addEventListener('click', function () { onRevealed('button'); });
  claimBtn.addEventListener('click', function () { show('email'); track('fsg_claim_view'); });

  /* ---------- step 1: email ---------- */
  var emailForm = steps.email, smsForm = steps.sms;
  var err1 = $('[data-fsg-err]'), err2 = $('[data-fsg-err2]');
  var phone = $('#fsg-phone'), cc = $('[data-fsg-cc]');
  var bot = false;
  (function presetCountry() {
    var def = (cc.getAttribute('data-default') || '').toUpperCase();
    for (var i = 0; i < cc.options.length; i++) {
      if (cc.options[i].value.split('|')[0] === def) { cc.selectedIndex = i; return; }
    }
  })();

  function e164(raw) {
    var v = String(raw || '').trim();
    if (!v) return '';
    if (v.charAt(0) === '+') return '+' + v.replace(/\D/g, '');
    var digits = v.replace(/\D/g, '').replace(/^0+/, '');
    if (!digits) return '';
    return '+' + cc.value.split('|')[1] + digits;
  }

  // National digit counts for the main markets, so a short number is caught here, not rejected silently later.
  var LENGTHS = { '1': [10], '61': [9], '44': [10], '64': [8, 9, 10], '353': [9], '971': [9], '65': [8], '852': [8], '49': [10, 11], '33': [9], '31': [9], '91': [10] };
  function validLength(tel) {
    var d = tel.replace(/\D/g, ''), codes = Object.keys(LENGTHS).sort(function (x, y) { return y.length - x.length; });
    for (var i = 0; i < codes.length; i++) {
      if (d.indexOf(codes[i]) === 0) return LENGTHS[codes[i]].indexOf(d.length - codes[i].length) !== -1;
    }
    return d.length >= 8 && d.length <= 15;
  }

  function send(payload) {
    if (bot) return;
    payload.design = TEST ? 'test' : C.design;
    payload.variant = C.variant;
    payload.code = C.code;
    payload.page = location.origin + location.pathname;
    payload.ts = new Date().toISOString();
    payload.hp = '';
    var body = new URLSearchParams(payload).toString();
    try {
      fetch(C.relay, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body }).catch(function () {
        try { navigator.sendBeacon(C.relay, new Blob([body], { type: 'application/x-www-form-urlencoded' })); } catch (e) {}
      });
    } catch (e) {
      try { navigator.sendBeacon(C.relay, new Blob([body], { type: 'application/x-www-form-urlencoded' })); } catch (e2) {}
    }
  }

  // Shopify's own newsletter signup: creates the Shopify customer, subscribed to email marketing.
  function shopifySubscribe(email) {
    if (bot) return;
    try {
      var b = new URLSearchParams({ form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[tags]': 'newsletter,scratch-card-signup', 'contact[accepts_marketing]': 'true' });
      fetch('/contact', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: b.toString() }).catch(function () {});
    } catch (e) {}
  }

  function identify(email, tel) {
    try {
      var o = window.omnisend;
      if (o && typeof o.identifyContact === 'function') o.identifyContact(tel ? { email: email, phone: tel } : { email: email });
    } catch (e) {}
  }

  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    err1.textContent = '';
    var email = emailForm.email.value.trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { err1.textContent = 'Add your email to claim your ' + C.amount + '.'; emailForm.email.focus(); return; }
    bot = !!emailForm.company.value;
    // Email is subscribed now, so it is captured even if they stop at the SMS step.
    send({ email: email, phone: '', smsConsent: 'no', step: 'email' });
    shopifySubscribe(email);
    identify(email, '');
    set('email', email);
    track('fsg_email');
    show('sms');
  });

  /* ---------- step 2: SMS (required to unlock the code) ---------- */
  smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    err2.textContent = '';
    var email = get('email') || emailForm.email.value.trim();
    var tel = e164(phone.value);
    if (tel.replace(/\D/g, '').length < 8) { err2.textContent = 'Add your mobile number to unlock your ' + C.amount + '.'; phone.focus(); return; }
    if (!validLength(tel)) { err2.textContent = 'That mobile number looks incomplete — check the digits and country code.'; phone.focus(); return; }
    if (!email) { show('email'); return; }
    send({
      email: email,
      phone: tel,
      smsConsent: 'yes',
      step: 'sms',
      consentText: 'By tapping Unlock, you agree to receive marketing texts from The Flaire. Reply STOP to opt out.'
    });
    identify(email, tel);
    set('claimed', '1'); set('done', '1');
    track('fsg_sms');
    track('fsg_submit');
    show('done');
  });

  // They copy the code themselves; nothing is applied to the cart automatically.
  var copyTop = $('[data-fsg-copy]'), copyMain = $('[data-fsg-copy2]'), codeEl = $('[data-fsg-code]');
  function copyCode() {
    function ok() { copyTop.textContent = 'Copied'; copyMain.textContent = 'Copied — start shopping'; copyMain.setAttribute('data-copied', '1'); track('fsg_copy'); }
    function fallback() {
      try { var r = document.createRange(); r.selectNodeContents(codeEl); var s = getSelection(); s.removeAllRanges(); s.addRange(r); } catch (x) {}
      copyTop.textContent = 'Selected'; copyMain.textContent = 'Start shopping'; copyMain.setAttribute('data-copied', '1');
    }
    try { navigator.clipboard.writeText(C.code).then(ok, fallback); } catch (x) { fallback(); }
  }
  copyTop.addEventListener('click', copyCode);
  copyMain.addEventListener('click', function () { if (copyMain.getAttribute('data-copied')) close(); else copyCode(); });

  /* ---------- triggers ---------- */
  if (TEST) { open('test'); return; }

  var snoozed = Number(get('snooze') || 0);
  var snoozeActive = snoozed && (Date.now() - snoozed) < SNOOZE_DAYS * 864e5;
  if (snoozeActive) return;

  var fired = false;
  function fire(source) {
    if (fired) return;
    if (otherModalOpen()) { setTimeout(function () { fire(source); }, 4000); return; }
    fired = true;
    window.removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onExit);
    open(source);
  }
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= SCROLL_PCT) fire('scroll');
  }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0) fire('exit'); }

  setTimeout(function () { fire('time'); }, DELAY_MS);
  window.addEventListener('scroll', onScroll, { passive: true });
  if (!MOBILE) document.addEventListener('mouseout', onExit);
})();
